
<template>
    <div class="position-relative">
        <slot></slot>
    </div>
</template>

<script>
    import autoComplete from '@tarekraafat/autocomplete.js';

    export default {
        data: function () {
            return {

            };
        },
        props: ["shippingAddressModel"],
        mounted: function () {
            var vm = this;
            const autoCompleteJS = new autoComplete({
                selector: "#City",
                data: {
                    src: async () => {
                        // Loading placeholder text
                        document.querySelector("#City").setAttribute("placeholder", "טוען...");
                        // Fetch External Data Source
                        const source = await fetch('https://data.gov.il/api/3/action/datastore_search?q=' +
                            ('{"שם_ישוב":"\'' + document.querySelector("#City").value + '\':*"' + '}') +
                            '&resource_id=d4901968-dad3-4845-a9b0-a57d027f11ab&limit=10&plain=false');
                        const data = await source.json();
                        // Post Loading placeholder text
                        document.querySelector("#City").setAttribute("placeholder", autoCompleteJS.placeHolder);
                        // Returns Fetched data
                        return data.result.records;
                    },
                    keys: ["שם_ישוב"],
                    key: ["#City"],
                    //cache: true,
                },
                searchEngine: "loose",
                placeHolder: "",
                maxResults: 5,
                highlight: true,
                debounce: 300,
                threshold: 0,
            });

            document.querySelector("#City").addEventListener("selection", function (event) {
                console.log(event.detail);
                vm.$props.shippingAddressModel.city = event.detail.selection.value["שם_ישוב"].trim().replace(")", "))").replace("(", ")").replace("))", "(");
            });
        },
        methods: {

        },
        computed: {

        }
    }
</script>